import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-8 md:py-14 bg-maternal-beige" data-id="element-139">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-141">
          <p className="text-xl md:text-2xl font-heading font-bold text-maternal-brown mb-2" data-id="element-142">
            ¿Lista para transformar tu relación con tu hijo?
          </p>
          <p className="text-maternal-lightBrown mb-6 text-sm md:text-base" data-id="element-143">
            Empezá hoy y notá los primeros cambios en 72 horas.
          </p>
          <CTAButton text="EMPEZAR AHORA" data-id="element-144" />
          <div className="flex items-center justify-center gap-2 mt-4 text-sm text-maternal-lightBrown/70" data-id="element-145">
            <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-146" />
            <span data-id="element-147">Pago seguro · Acceso inmediato · Sin riesgo</span>
          </div>
        </motion.div>
      </div>
    </section>;
}